















import { SXSurvey } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";
import app from "@/app";

@Component
export default class WSurveyMenu extends BaseComponent {
	@Prop({ type: SXSurvey, required: true })
	survey!: SXSurvey;

	get surveyMenu() {
		let id = this.survey.id;
		const menuDefault = [
				{
					title: "SX_LANG_SURVEY_RUN",
					icon: "fa-play",
					link: `/surveys/${id}/run`
				},
				{
					title: "SX_LANG_ABOUT",
					icon: "fa-info",
					link: `/surveys/${id}/about`
				}
			],
			menuAdmin = [
				{
					title: "SX_LANG_SURVEY_ANSWERS",
					icon: "fa-inbox",
					link: `/surveys/${id}/answers`
				},
				{
					title: "SX_LANG_SURVEY_STATS",
					icon: "fa-chart-line",
					link: `/surveys/${id}/stats`
				},
				{
					title: "SX_LANG_SURVEY_UNSENT_ANSWERS",
					icon: "fa-hourglass-start",
					link: `/surveys/${id}/answers/unsent`
				},
				{
					title: "SX_LANG_SURVEY_BUILDER",
					icon: "fa-plus",
					link: `/surveys/${id}/build`
				},
				{
					title: "SX_LANG_SURVEY_EDIT",
					icon: "fa-edit",
					link: `/surveys/${id}/edit`
				}
			];

		if (this.isCompanyAdmin) {
			return [menuDefault, menuAdmin];
		}

		return [menuDefault];
	}
	get isCompanyAdmin() {
		return this.$services.users.isCompanyAdmin(this.survey.company_id);
	}

	get customUrl() {
		let x = this;
		return (
			this.survey &&
			app.services.urls.select(undefined, function(item) {
				return item.target === `sx_surveys_${x.survey!.id}`;
			})[0]
		);
	}

	deleteSurvey() {
		let ok = confirm(
			app.i18n.toHuman("SX_LANG_DELETE_CONFIRM", {
				name: this.survey.name
			})
		);
		if (ok) {
			this.$services.surveys.deleteItem(
				this.survey,
				function() {
					app.router.goBack();
					app.view.dialog({
						type: "error",
						text: "SX_LANG_SURVEY_DELETE_SUCCESS"
					});
				},
				function() {
					app.view.dialog({
						type: "error",
						text: "SX_LANG_SURVEY_DELETE_ERROR"
					});
				},
				true
			);
		}
	}
}
